import { Component, HostListener } from '@angular/core';
import { FloatingButtonAction, FloatingButtonSettingsService } from '../../service/FloatingButtonSettings/floating-button-settings.service';

@Component({
  standalone: false,
  selector: 'app-floating-buttons',
  templateUrl: './floating-buttons.component.html',
  styleUrls: ['./floating-buttons.component.scss'],
})
export class FloatingButtonsComponent {
  constructor(public floatingButtons: FloatingButtonSettingsService) {}

  run(action: FloatingButtonAction, event: Event): void {
    event.stopPropagation();
    if (action.disabled?.()) return;
    try {
      const result = action.handler();
      if (result instanceof Promise) void result.catch(error => console.error(`Floating action failed: ${action.id}`, error));
    } catch (error) {
      console.error(`Floating action failed: ${action.id}`, error);
    }
  }

  @HostListener('document:ionModalWillPresent', ['$event'])
  @HostListener('document:ionAlertWillPresent', ['$event'])
  @HostListener('document:ionPopoverWillPresent', ['$event'])
  @HostListener('document:ionActionSheetWillPresent', ['$event'])
  onOverlayWillPresent(event: Event): void {
    this.floatingButtons.setOverlayPresented(event.target ?? event, true);
  }

  @HostListener('document:ionModalDidDismiss', ['$event'])
  @HostListener('document:ionAlertDidDismiss', ['$event'])
  @HostListener('document:ionPopoverDidDismiss', ['$event'])
  @HostListener('document:ionActionSheetDidDismiss', ['$event'])
  onOverlayDidDismiss(event: Event): void {
    this.floatingButtons.setOverlayPresented(event.target ?? event, false);
  }
}
